module.exports = __webpack_public_path__ + "static/img/icon5-6.0527696d.png";